// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import { masked } from 'store/reducers/ajaxCall/selectors';
import { getIsDeeplinking } from 'store/reducers/deeplink/selectors';
import { isLoadingAppointment } from 'store/reducers/userInteractions/selectors';

import { LoadingAppointment, Mask } from 'components/atoms/Mask';

type Props = {|
  /**
   * True to show the default mask
   */
  masked: boolean,
  /**
   * True to show the LoadingAppointment mask
   */
  isLoadingAppointment: boolean
|};

// eslint-disable-next-line react/prop-types
const AppMask = ({ masked, isLoadingAppointment }: Props) => {
  if (masked) {
    return <Mask />;
  }
  if (isLoadingAppointment) {
    return <LoadingAppointment />;
  }
  return null;
};

function mapStateToProps(state): $Shape<Props> {
  return {
    masked: masked(state),
    isLoadingAppointment: getIsDeeplinking(state) || isLoadingAppointment(state)
  };
}

export default connect(mapStateToProps)(AppMask);



// WEBPACK FOOTER //
// ./src/components/consumer8/AppMask.js